"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCoverageTracker_1 = require("./useCoverageTracker");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useCoverageTracker_1.default; } });
//# sourceMappingURL=index.js.map